import { Record } from "immutable";

export interface MailTemplateTestFormParams {
    mail_address: string | null;
    via: number | null;
}

const defaults: MailTemplateTestFormParams = {
    mail_address: null,
    via: null,
};

class MailTemplateTestForm extends Record<MailTemplateTestFormParams>(defaults) {
    constructor(values?: Partial<MailTemplateTestFormParams>) {
        super(values ? { ...defaults, ...values } : defaults);
    }

    createFormData(): string {
        if (!this.mail_address) {
            throw new Error("Title must be defined");
        }
        if (this.via === null) {
            throw new Error("From address must be defined");
        }

        // Create a JSON object with the necessary fields
        const obj = {
            mail_address: this.mail_address,
            via: this.via,
        };

        return JSON.stringify(obj);
    }
}

export default MailTemplateTestForm;
